import { Component, OnInit, Input } from '@angular/core';
import { AdminQuestion, Answer, QuestionType, CompositeAnswerPortion } from '../../../models/questions';

@Component({
  selector: 'app-question-matrix',
  templateUrl: './question-matrix.component.html',
  styleUrls: ['./question-matrix.component.scss']
})
export class QuestionMatrixComponent implements OnInit {
  @Input() question: AdminQuestion = {};

  questionType: any = QuestionType;
  answerRows: Array<Answer>;
  answerColumns: Array<Answer>;

  constructor() { }

  ngOnInit() {
    this.sortAnswersByOrder(this.question.answers);
    this.answerRows = this.getAnswerRows(this.question.answers);
    this.answerColumns = this.getAnswerColumns(this.question.answers);
  }

  getIsMatrixCheckbox(): boolean {
    return this.question.answerType === QuestionType.MatrixCheckbox;
  }

  private getAnswerRows(answers: Array<Answer>): Array<Answer> {
    return answers.filter(x => x.compositeAnswerPortion === CompositeAnswerPortion.Row);
  }

  private getAnswerColumns(answers: Array<Answer>): Array<Answer> {
    return answers.filter(x => x.compositeAnswerPortion === CompositeAnswerPortion.Column);
  }

  private sortAnswersByOrder(answers: Array<Answer>) {
    return answers.sort((a, b) => a.order - b.order);
  }
}
